// Generated by scripts/build-ui-icons.mjs.
export { Trophy as default } from "../ui/glyphs-7";
